<template>
	<div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
		<div>
			<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">
				{{ $t('integrations.create-assign-catalog') }}
			</div>
			<!--			<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">-->
			<!--				{{ $t('integrations.create-assign-catalog-desc') }}-->
			<!--			</div>-->
			<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
				{{ $t('integrations.create-new-catalog-desc') }}
			</div>
			<!--            <template v-if="!isNew && !isExisting">-->
			<!--                <div class="tw-mt-5 tw-flex tw-gap-3">-->
			<!--                    <AppButton-->
			<!--                        :label="$t('integrations.i-am-using-an-existing-catalog')"-->
			<!--                        size="xl"-->
			<!--                        class="tw-rounded-full"-->
			<!--                        @click="showGuid(false)"-->
			<!--                        secondary-->
			<!--                        variant="gray"-->
			<!--                    />-->

			<!--                    <AppButton-->
			<!--                        :label="$t('integrations.i-am-creating-new-catalog')"-->
			<!--                        size="xl"-->
			<!--                        class="tw-rounded-full"-->
			<!--                        @click="showGuid(true)"-->
			<!--                    />-->
			<!--                </div>-->
			<!--            </template>-->
		</div>

		<!--        <template v-else>-->
		<GuidCreateNew />
		<!--            <GuidUseExisting v-if="isExisting"/>-->
		<!--        </template>-->

		<div
			class="tw-mt-7 tw-flex tw-flex-1 tw-items-end"
			:class="isNew || isExisting ? 'tw-justify-between' : 'tw-justify-end'"
		>
			<AppButton
				v-if="isNew || isExisting"
				:label="$t('integrations.complete-step')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/check.svg"
				@click="nextStep"
				:disabled="nextStepLoading"
			/>

			<a v-if="configs.brand == 'Linker'" :href="needHelpUrl" target="_blank">
				<AppButton
					:label="$t('integrations.need-help')"
					variant="secondary"
					endIcon="assets/v2/image/icons/help-circle.svg"
					class="tw-rounded-full"
					size="xl"
				/>
			</a>
		</div>
	</div>
</template>

<script setup>
import GuidCreateNew from './guid-create-new';
import GuidUseExisting from './guid-use-existing';

import { Marketplace } from '@/v2/modules/integrations/entities/marketplace';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { ref } from 'vue';
import { configs } from '@/v2/system-configs';

const linkMarketplaceStore = useLinkMarketplaceStore();

const nextStepLoading = ref(false);
const isNew = ref(true);
const isExisting = ref(false);
const needHelpUrl =
	'https://www.linker.com.sa/help-center-articles-ar/setting-up-your-catalog-in-facebook-business-manager';

const showGuid = (newGuid) => {
	if (newGuid) {
		isNew.value = true;
		needHelpUrl.value = '';
	} else {
		isExisting.value = true;
		needHelpUrl.value = '';
	}
};

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
